import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import A from '../Basic/A';
import ANoStyle from '../Basic/ANoStyle';
import Desc from '../Basic/Desc';
import Heading from '../Basic/Heading';
import EAvo from '../Emoji/EAvo';
import EFire from '../Emoji/EFire';
import EFox from '../Emoji/EFox';
import EMagic from '../Emoji/EMagic';
import ERofl from '../Emoji/ERofl';
import ESpeak from '../Emoji/ESpeak';
import ETree from '../Emoji/ETree';
import EUnicorn from '../Emoji/EUnicorn';
import EVic from '../Emoji/EVic';
import EWrite from '../Emoji/EWrite';

export default () => (
	<Wrap>
		<Heading>
			<ANoStyle href="https://twitter.com/MrAhmadAwais/">
				<Img>
					<Inner
						loading="lazy"
						className="lazyload"
						data-src="https://res.cloudinary.com/cdemo/image/upload/w_150,h_150,q_auto:best,f_auto/Placeholders/k9lwmmovetxmmdp3wv5s"
						alt="Ahmad Awais"
					/>
				</Img>
			</ANoStyle>
			<Dull>Who's behind this?!</Dull>
			<ANoStyle href="https://twitter.com/MrAhmadAwais/" title="Ahmad Awais">
				Ahmad Awais
			</ANoStyle>
		</Heading>
		<Desc>
			<EMagic /> Full-time #OpenSourcerer <EFox /> Google Developers Expert <EAvo /> Web Dev Advocate <ETree />{' '}
			Node.js Community Committee Member <ERofl /> A Self-confessed hilarious comedian
			<EVic /> Author of various{' '}
			<A href="https://github.com/AhmadAwais">open-source dev-tools and software libraries </A> used by millions
			of developers worldwide (inc. engineers at Google, AWS, Microsoft, Intel, HP…) <ESpeak /> TEDx Speaker{' '}
			<EFire /> Regular WordPress Core Developer <EWrite /> Member of SmashingMagazine Experts Panel,{' '}
			<A href="https://AhmadAwais.com/">Featured/published author</A> at CSS-Tricks, Tuts+, Scotch.io, TorqueMag,
			SitePoint… You should follow him on twitter <A href="https://twitter.com/MrAhmadAwais/">@MrAhmadAwais</A>.
			<Sop>
				It's a known fact that Awais loves purple. Purple can be genius. He built a VSCode theme which quickly
				became the third most downloaded VSCode theme with millions of downloads. Over 110 developers swear by
				its awesomeness with five-star ratings. <br /> <EUnicorn /> Install it here{' '}
				<A href="https://marketplace.visualstudio.com/items?itemName=ahmadawais.shades-of-purple">
					Shades of Purple →
				</A>
			</Sop>
		</Desc>
	</Wrap>
);

const Wrap = styled.div`
	display: table;
	width: 100%;
	max-width: 75rem;
	margin: 0 auto;

	p {
		${rmq('t')} {
			text-align: left;
		}
	}
`;
const Img = styled.div`
	display: table;
	width: 100%;
	text-align: center;
	position: relative;
	margin: 3.2rem auto 6.4rem;

	${rmq('ml')} {
		margin: 2.2rem auto 3.4rem;
	}

	&::before,
	&::after {
		content: '';
		background: linear-gradient(to right, ${(props) => props.theme.c1}, ${(props) => props.theme.c2});
		position: absolute;
		width: 30%;
		height: 100%;
		transform: rotateZ(5deg);
		left: 35%;
		top: 0;
		right: 50%;
		z-index: -1;

		${rmq('ml')} {
			width: 40%;
			left: 30%;
		}
		${rmq('ms')} {
			width: 45%;
			left: 27%;
		}
	}
	&::after {
		transform: rotateZ(15deg);
	}
`;
const Inner = styled.img`
	z-index: 1;
	width: 15rem;
	height: 15rem;
	border-radius: 500rem;
	padding: 2rem;
	transition: all 0.4s ease;

	&:hover {
		box-shadow: 0 0 12rem 0 rgba(22, 22, 22, 0.2);
	}
`;

const Dull = styled.div`
	color: ${(props) => props.theme.cg};
	font-size: 1.6rem;
	font-family: ${(props) => props.theme.f1};
	font-weight: 400;
	font-style: italic;
`;

const Sop = styled.span`
	display: block;
	width: 100%;
	margin: 2rem auto;
	padding: 3rem 0 1rem;
	position: relative;
	font-style: italic;

	&::before {
		content: '';
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		display: block;
		height: 1px;
		background: linear-gradient(
			to right,
			rgba(227, 231, 235, 0.1) 0px,
			rgba(227, 231, 235, 0.6) 50%,
			rgba(227, 231, 235, 0.1) 100%
		);
	}
`;
